export default function currencyNoSymbol(value: string | number): string {
    if (value?.toString() === '') return '';
    const val = value?.toString().length && !Number.isNaN(value) ? value : 0;
    return Number(val).toFixed(2);
}
